'use client'

import type { CSSProperties } from 'react'
import { GolfBall } from './GolfBall'
import type { CalloutCopy } from './calloutCopy'
import type { CalloutView } from './calloutState'

type Props = Readonly<{
  view: CalloutView
  copy: CalloutCopy
  /** False under reduced motion: the pill is simply there until the host drops it. */
  animate?: boolean
  className?: string
  style?: CSSProperties
}>

/**
 * The putt callout pill (B34). The HOST keys the element per putt so a new
 * putt remounts it and the CSS keyframe (in, hold, out) starts over; the host
 * also drops it after `CALLOUT_MS`, which is what removes it under reduced
 * motion where the keyframe is collapsed.
 */
export function BirdieCallout({ view, copy, animate = true, className, style }: Props) {
  const classes = [
    'birdie-callout',
    `birdie-callout--${view.kind}`,
    animate ? '' : 'birdie-callout--instant',
    className ?? ''
  ]
    .filter(Boolean)
    .join(' ')
  return (
    <div aria-live="polite" className={classes} role="status" style={style}>
      <span className="birdie-callout__eyebrow">{copy.eyebrow}</span>
      <span aria-hidden="true" className="birdie-callout__ball">
        <GolfBall className="birdie-callout__ball-svg" />
      </span>
      <span className="birdie-callout__word">{copy.word}</span>
    </div>
  )
}
